import { useState } from "react";
import { Btn, FieldLabel, Input, Modal, Sel } from "components/ui/index";
import { T } from "theme/index";
import { uid } from "utils/format";

// ── Category Modal ────────────────────────────────────────────────────────────
const EMOJIS = ["💰","💵","📈","🏠","🛡️","₿","🔥","💳","🚨","🍜","🚗","🎮","💊","🛒","📤","➕","🎯","💡","🏋️","✈️","📚","🎵","🐾","💻","🔧","📌","⚡","🌱","🎪","🍕","☕","🎁","👶","🧾","🏥","🎓","🛠️","🐶","🎬","👕","🧴","🚿","📱","🛋️","🍺","🚬","💇","🏦","🧳","🎂","🚕"];
const COLORS_PRESET = ["#EF4444","#F97316","#F59E0B","#22C55E","#0EA5E9","#3B82F6","#8B5CF6","#EC4899","#06B6D4","#10B981","#F7931A","#6B7280","#A78BFA","#FB923C","#64748B"];

export default function CatModal({ cat, onSave, onClose }) {
  const [f, setF] = useState(cat || { id:uid(), name:"", type:"expense", color:"#3B82F6", icon:"📌" });
  const set = (k, v) => setF(p => ({ ...p, [k]:v }));
  return (
    <Modal title={cat ? "Edit Kategori" : "Tambah Kategori"} onClose={onClose}>
      <Input label="Nama Kategori" value={f.name} onChange={e => set("name",e.target.value)} placeholder="Nama kategori..." />
      <Sel label="Tipe" value={f.type} onChange={e => set("type",e.target.value)} options={[{value:"income",label:"💰 Pemasukan"},{value:"expense",label:"💸 Pengeluaran"},{value:"investasi",label:"📈 Investasi"}]} />
      <div style={{ marginBottom:14 }}>
        <FieldLabel>Warna</FieldLabel>
        <div style={{ display:"flex", gap:6, flexWrap:"wrap", alignItems:"center" }}>
          {COLORS_PRESET.map(c => (
            <button key={c} onClick={() => set("color",c)} style={{ width:30, height:30, borderRadius:6, background:c, border:`2px solid ${f.color===c?"#fff":"transparent"}`, cursor:"pointer", flexShrink:0, WebkitTapHighlightColor:"transparent" }} />
          ))}
          <input type="color" value={f.color} onChange={e => set("color",e.target.value)} style={{ width:30, height:30, padding:2, borderRadius:6, border:`1px solid ${T.border}`, cursor:"pointer", background:T.surface }} />
        </div>
      </div>
      <div style={{ marginBottom:16 }}>
        <FieldLabel>Ikon</FieldLabel>
        <div style={{ display:"flex", gap:5, flexWrap:"wrap" }}>
          {EMOJIS.map(e => (
            <button key={e} onClick={() => set("icon",e)} style={{ width:36, height:36, borderRadius:6, fontSize:18, cursor:"pointer", background:f.icon===e?T.gold+"25":T.surface, border:`1px solid ${f.icon===e?T.gold:T.border}`, WebkitTapHighlightColor:"transparent" }}>{e}</button>
          ))}
        </div>
      </div>
      <div style={{ display:"flex", justifyContent:"flex-end", gap:8 }}>
        <Btn variant="ghost" onClick={onClose}>Batal</Btn>
        <Btn onClick={() => { if(f.name){ onSave(f); onClose(); }}} disabled={!f.name}>💾 Simpan</Btn>
      </div>
    </Modal>
  );
}
